import { render, staticRenderFns } from "./addAdvice.vue?vue&type=template&id=8d93d62e&scoped=true&"
import script from "./addAdvice.vue?vue&type=script&lang=js&"
export * from "./addAdvice.vue?vue&type=script&lang=js&"
import style0 from "./addAdvice.vue?vue&type=style&index=0&id=8d93d62e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d93d62e",
  null
  
)

export default component.exports